import { TranscriptionSessionEndCommand } from '@dreryk/egabinet-ai-assistant-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';

type TranscriptionSessionEndedParameters = {
   durationSeconds: number;
   token: string;
};

export const useTranscriptionSessionEnded = (): UseCqrsCommandResult<void, TranscriptionSessionEndedParameters> => {
   return useCqrsCommand<void, TranscriptionSessionEndedParameters>(
      (parameters) => {
         const command = new TranscriptionSessionEndCommand();
         command.durationSeconds = parameters.durationSeconds;
         command.token = parameters.token;
         return command;
      },
      {
         background: true,
      }
   );
};
